var React = require('react');

function ContactFlag1 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#eaf4f3","fillRule":"evenodd","transform":"matrix(-1 0 0 1 1440 0)"},[React.createElement("path",{"d":"m140.344316 180.975616 1168.966334-674.975616 37.68935 585.3071981-943.832078 544.9803129z","opacity":".535203","transform":"matrix(.8660254 .5 -.5 .8660254 135.205055 -362.304623)","key":0}),React.createElement("path",{"d":"m-21.9796002 218.268539 1203.6105002-694.976906 37.68961 585.308101-978.475641 564.981354z","transform":"matrix(.8660254 .5 -.5 .8660254 129.424812 -286.147255)","key":1})]));
}

ContactFlag1.defaultProps = {"height":"418","preserveAspectRatio":"none","viewBox":"0 0 1439 418","width":"1439"};

module.exports = ContactFlag1;

ContactFlag1.default = ContactFlag1;
